// Where the portal opens: after signing in, and at the bare address.
export const HOME = '/dashboard/plans';
